// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.leadFullDataShow-container {
  max-width: 1100px;
  margin: 0 auto;
  padding: 15px;
  background-color: #f7fafc;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
  min-height: 100vh;
}

.leadFullDataShow-title {
  font-size: 1.75rem;
  font-weight: 700;
  color: #2d3748;
  text-align: center;
  margin-bottom: 1.5rem;
}

.leadFullDataShow-card {
  background: linear-gradient(180deg, #ffffff 0%, #f1f5f9 100%);
  border-radius: 6px;
  padding: 1rem;
  margin-bottom: 1rem;
}

.leadFullDataShow-sectionTitle {
  font-size: 1.25rem;
  font-weight: 600;
  color: #319795;
  margin-bottom: 0.75rem;
}

.leadFullDataShow-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0.75rem;
}

.leadFullDataShow-infoItem {
  display: flex;
  flex-direction: column;
  padding: 0.5rem;
}

.leadFullDataShow-infoLabel {
  font-size: 0.85rem;
  font-weight: 500;
  color: #4a5568;
}

.leadFullDataShow-infoValue {
  font-size: 0.95rem;
  color: #1a202c;
  word-break: break-word;
}

.leadFullDataShow-buttons {
  display: flex;
  flex-direction: row;
  gap: 0.75rem;
  justify-content: center;
  margin-top: 1rem;
}

.leadFullDataShow-button {
  background-color: #319795;
  color: #ffffff;
  font-weight: 600;
  padding: 0.6rem 1.2rem;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.2s ease, transform 0.1s ease;
}

.leadFullDataShow-button:hover {
  background-color: #2c7a7b;
  transform: translateY(-1px);
}

.leadFullDataShow-button:active {
  transform: translateY(0);
}

.leadFullDataShow-cancelButton {
  background-color: #a0aec0;
}

.leadFullDataShow-cancelButton:hover {
  background-color: #718096;
}

.leadFullDataShow-loading {
  text-align: center;
  font-size: 1rem;
  color: #4a5568;
  padding: 2rem 0;
}

.leadFullDataShow-error {
  text-align: center;
  font-size: 1rem;
  color: #e53e3e;
  padding: 2rem 0;
}

/* Modal Styles */
.leadFullDataShow-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.leadFullDataShow-modalContent {
  background-color: #ffffff;
  border-radius: 6px;
  padding: 1.5rem;
  max-width: 800px;
  width: 90%;
  max-height: 80vh;
  overflow-y: auto;
}

.leadFullDataShow-form {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.leadFullDataShow-formSection {
  border-bottom: 1px solid #e2e8f0;
  padding-bottom: 1rem;
}

.leadFullDataShow-formSectionTitle {
  font-size: 1.1rem;
  font-weight: 600;
  color: #319795;
  margin-bottom: 0.5rem;
}

.leadFullDataShow-formInput {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  margin-bottom: 0.75rem;
}

.leadFullDataShow-input {
  padding: 0.5rem;
  border: 1px solid #e2e8f0;
  border-radius: 4px;
  font-size: 0.9rem;
  color: #1a202c;
}

.leadFullDataShow-input:focus {
  outline: none;
  border-color: #319795;
  box-shadow: 0 0 0 2px rgba(49, 151, 149, 0.2);
}

.leadFullDataShow-formButtons {
  display: flex;
  flex-direction: row;
  gap: 0.75rem;
  justify-content: flex-end;
}

/* Additional Need Styles */
.leadFullDataShow-additionalNeed {
  grid-column: span 3;
  padding: 0.5rem;
}

.leadFullDataShow-additionalNeedItem {
  border-left: 2px solid #319795;
  padding-left: 1rem;
  margin-top: 0.5rem;
}

.leadFullDataShow-additionalNeedForm {
  border: 1px solid #e2e8f0;
  padding: 1rem;
  border-radius: 4px;
}
.leadFormInput_dropdown {
  margin-bottom: 1rem;
  display: flex;
  flex-direction: column;
}

.leadFormInput_label {
  font-weight: 600;
  margin-bottom: 0.25rem;
}

.leadFormInput_select {
  padding: 0.5rem;
  border: 1px solid #ccc;
  border-radius: 0.5rem;
}

/* Responsive Design */
@media (max-width: 1024px) {
  .leadFullDataShow-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .leadFullDataShow-title {
    font-size: 1.5rem;
  }

  .leadFullDataShow-modalContent {
    width: 95%;
  }

  .leadFullDataShow-additionalNeed {
    grid-column: span 2;
  }
}

@media (max-width: 640px) {
  .leadFullDataShow-container {
    padding: 10px;
  }

  .leadFullDataShow-title {
    font-size: 1.25rem;
  }

  .leadFullDataShow-sectionTitle {
    font-size: 1.1rem;
  }

  .leadFullDataShow-grid {
    grid-template-columns: 1fr;
  }

  .leadFullDataShow-buttons {
    flex-direction: column;
    align-items: center;
  }

  .leadFullDataShow-button {
    width: 100%;
    max-width: 280px;
    padding: 0.5rem 1rem;
  }

  .leadFullDataShow-infoItem {
    padding: 0.25rem;
  }

  .leadFullDataShow-modalContent {
    padding: 1rem;
    max-height: 90vh;
  }

  .leadFullDataShow-formButtons {
    flex-direction: column;
    align-items: stretch;
  }

  .leadFullDataShow-additionalNeed {
    grid-column: span 1;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/leadfulldatashow.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,yBAAyB;EACzB,8EAA8E;EAC9E,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,6DAA6D;EAC7D,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,2DAA2D;AAC7D;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA,2BAA2B;AAC3B;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA,sBAAsB;AACtB;EACE;IACE,qCAAqC;EACvC;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,oBAAoB;EACtB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;EACrB;AACF","sourcesContent":[".leadFullDataShow-container {\n  max-width: 1100px;\n  margin: 0 auto;\n  padding: 15px;\n  background-color: #f7fafc;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, sans-serif;\n  min-height: 100vh;\n}\n\n.leadFullDataShow-title {\n  font-size: 1.75rem;\n  font-weight: 700;\n  color: #2d3748;\n  text-align: center;\n  margin-bottom: 1.5rem;\n}\n\n.leadFullDataShow-card {\n  background: linear-gradient(180deg, #ffffff 0%, #f1f5f9 100%);\n  border-radius: 6px;\n  padding: 1rem;\n  margin-bottom: 1rem;\n}\n\n.leadFullDataShow-sectionTitle {\n  font-size: 1.25rem;\n  font-weight: 600;\n  color: #319795;\n  margin-bottom: 0.75rem;\n}\n\n.leadFullDataShow-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 0.75rem;\n}\n\n.leadFullDataShow-infoItem {\n  display: flex;\n  flex-direction: column;\n  padding: 0.5rem;\n}\n\n.leadFullDataShow-infoLabel {\n  font-size: 0.85rem;\n  font-weight: 500;\n  color: #4a5568;\n}\n\n.leadFullDataShow-infoValue {\n  font-size: 0.95rem;\n  color: #1a202c;\n  word-break: break-word;\n}\n\n.leadFullDataShow-buttons {\n  display: flex;\n  flex-direction: row;\n  gap: 0.75rem;\n  justify-content: center;\n  margin-top: 1rem;\n}\n\n.leadFullDataShow-button {\n  background-color: #319795;\n  color: #ffffff;\n  font-weight: 600;\n  padding: 0.6rem 1.2rem;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  transition: background-color 0.2s ease, transform 0.1s ease;\n}\n\n.leadFullDataShow-button:hover {\n  background-color: #2c7a7b;\n  transform: translateY(-1px);\n}\n\n.leadFullDataShow-button:active {\n  transform: translateY(0);\n}\n\n.leadFullDataShow-cancelButton {\n  background-color: #a0aec0;\n}\n\n.leadFullDataShow-cancelButton:hover {\n  background-color: #718096;\n}\n\n.leadFullDataShow-loading {\n  text-align: center;\n  font-size: 1rem;\n  color: #4a5568;\n  padding: 2rem 0;\n}\n\n.leadFullDataShow-error {\n  text-align: center;\n  font-size: 1rem;\n  color: #e53e3e;\n  padding: 2rem 0;\n}\n\n/* Modal Styles */\n.leadFullDataShow-modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.leadFullDataShow-modalContent {\n  background-color: #ffffff;\n  border-radius: 6px;\n  padding: 1.5rem;\n  max-width: 800px;\n  width: 90%;\n  max-height: 80vh;\n  overflow-y: auto;\n}\n\n.leadFullDataShow-form {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.leadFullDataShow-formSection {\n  border-bottom: 1px solid #e2e8f0;\n  padding-bottom: 1rem;\n}\n\n.leadFullDataShow-formSectionTitle {\n  font-size: 1.1rem;\n  font-weight: 600;\n  color: #319795;\n  margin-bottom: 0.5rem;\n}\n\n.leadFullDataShow-formInput {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n  margin-bottom: 0.75rem;\n}\n\n.leadFullDataShow-input {\n  padding: 0.5rem;\n  border: 1px solid #e2e8f0;\n  border-radius: 4px;\n  font-size: 0.9rem;\n  color: #1a202c;\n}\n\n.leadFullDataShow-input:focus {\n  outline: none;\n  border-color: #319795;\n  box-shadow: 0 0 0 2px rgba(49, 151, 149, 0.2);\n}\n\n.leadFullDataShow-formButtons {\n  display: flex;\n  flex-direction: row;\n  gap: 0.75rem;\n  justify-content: flex-end;\n}\n\n/* Additional Need Styles */\n.leadFullDataShow-additionalNeed {\n  grid-column: span 3;\n  padding: 0.5rem;\n}\n\n.leadFullDataShow-additionalNeedItem {\n  border-left: 2px solid #319795;\n  padding-left: 1rem;\n  margin-top: 0.5rem;\n}\n\n.leadFullDataShow-additionalNeedForm {\n  border: 1px solid #e2e8f0;\n  padding: 1rem;\n  border-radius: 4px;\n}\n.leadFormInput_dropdown {\n  margin-bottom: 1rem;\n  display: flex;\n  flex-direction: column;\n}\n\n.leadFormInput_label {\n  font-weight: 600;\n  margin-bottom: 0.25rem;\n}\n\n.leadFormInput_select {\n  padding: 0.5rem;\n  border: 1px solid #ccc;\n  border-radius: 0.5rem;\n}\n\n/* Responsive Design */\n@media (max-width: 1024px) {\n  .leadFullDataShow-grid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .leadFullDataShow-title {\n    font-size: 1.5rem;\n  }\n\n  .leadFullDataShow-modalContent {\n    width: 95%;\n  }\n\n  .leadFullDataShow-additionalNeed {\n    grid-column: span 2;\n  }\n}\n\n@media (max-width: 640px) {\n  .leadFullDataShow-container {\n    padding: 10px;\n  }\n\n  .leadFullDataShow-title {\n    font-size: 1.25rem;\n  }\n\n  .leadFullDataShow-sectionTitle {\n    font-size: 1.1rem;\n  }\n\n  .leadFullDataShow-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .leadFullDataShow-buttons {\n    flex-direction: column;\n    align-items: center;\n  }\n\n  .leadFullDataShow-button {\n    width: 100%;\n    max-width: 280px;\n    padding: 0.5rem 1rem;\n  }\n\n  .leadFullDataShow-infoItem {\n    padding: 0.25rem;\n  }\n\n  .leadFullDataShow-modalContent {\n    padding: 1rem;\n    max-height: 90vh;\n  }\n\n  .leadFullDataShow-formButtons {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .leadFullDataShow-additionalNeed {\n    grid-column: span 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
